import { Cookie } from '~/types/Cookie.ts';

interface CookieTableProps {
  cookies: Cookie[];
}

const CookieTable: React.FC<CookieTableProps> = ({ cookies }) => (
  <table className="w-full text-sm">
    <thead>
      <tr className="border-b text-left text-gray-600">
        <th className="pb-2 font-medium">Naam</th>
        <th className="pb-2 font-medium">Partij</th>
        <th className="pb-2 font-medium">Doeleinde</th>
        <th className="pb-2 font-medium">Duratie</th>
      </tr>
    </thead>
    <tbody>
      {cookies.map((cookie, index) => (
        <tr key={index} className="border-b last:border-b-0">
          <td className="font-mono py-3 text-xs">{cookie.name}</td>
          <td className="py-3 text-stone-700">
            {cookie.link ? (
              <a
                href={cookie.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {cookie.provider}
              </a>
            ) : (
              cookie.provider
            )}
          </td>
          <td className="py-3 pr-2 text-stone-600 md:w-[60%]">
            {cookie.purpose}
          </td>
          <td className="py-3 text-stone-600">{cookie.duration}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default CookieTable;
